import {Component, ChangeDetectionStrategy, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'oph-color-picker',
  templateUrl: './oph-color-picker.component.html',
  styleUrls: ['./oph-color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphColorPickerComponent {
  @Input()
  public colors: string[];
  @Input()
  public onCancel: () => void;

  @Output()
  public selectedColor: EventEmitter<string> = new EventEmitter<string>();

  onColorSelect(color: string): void {
    this.selectedColor.emit(color);
  }
}
